<template>
  <div>
    <el-dialog :title="form.isCreate ? '添加模板' : '修改模板'" center :visible="true" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="710px">
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="form.name" placeholder="用于区分不同的模板" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="附件：" prop="props">
          <MailAttachmentListBuilder ref="mailAttachmentListBuilder" :attachments="form.attachments">
          </MailAttachmentListBuilder>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");

import MailAttachmentListBuilder from "@/pages/mail/components/MailAttachmentListBuilder";

// 本弹窗名称
const DialogName = "EditMailPropsTemplateDialog";

export default {
  data() {
    return {
      form: {
        isCreate: true,
        name: "",
        attachments: [],
      },
    };
  },
  components: {
    MailAttachmentListBuilder,
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.form.isCreate = value.isCreate;

    if (!this.form.isCreate) {
      this.form.id = value.entry.id;
      this.form.name = value.entry.name;
      this.form.attachments = value.entry.props.map((e) => {
        return {
          id: e.id,
          num: e.amount,
        }
      });
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.form.name = this.form.name.trim();
      if (this.form.name.length == 0) {
        this.$message({
          message: "名称不能为空",
          type: "error",
        });
        return;
      }

      // 取得附件集合
      let attachments = [];
      {
        let getDataResult = this.$refs.mailAttachmentListBuilder.getData();
        if (getDataResult.errorMessage) {
          this.$message({
            message: getDataResult.errorMessage,
            type: "error",
          });
          return;
        }

        attachments = getDataResult.data.attachments;
      }

      if (attachments.length == 0) {
        this.$message({
          message: "请至少选择一种附件",
          type: "error",
        });
        return;
      }

      if (this.form.isCreate) {
        this.add(attachments);
      } else {
        this.update(attachments);
      }
    },

    /**
     * 新增
     */
    async add(attachments) {
      try {
        // 弹确认框
        await this.$confirm(`确认新增附件？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/addMailPropsTemplate`,
            {
              name: this.form.name,
              props: JSON.stringify(attachments.map((e) => {
                return {
                  id: e.id,
                  amount: e.num,
                }
              })),
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        // 弹确认框
        await this.$confirm(`添加成功`, { showCancelButton: false });

        // 关闭当前对话框
        this.onClose();
      } catch (e) { }
    },

    /**
     * 修改
     */
    async update(attachments) {
      try {
        // 弹确认框
        await this.$confirm(`确认修改附件？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/updateMailPropsTemplate`,
            {
              id: this.form.id,
              name: this.form.name,
              props: JSON.stringify(attachments.map((e) => {
                return {
                  id: e.id,
                  amount: e.num,
                }
              })),
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();
      } catch (e) { }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>